<script>
    import HamburgerMenuComponent from "../../components/pagesbuilder/dynamic-components/HamburgerMenuComponent";
    import PreviewComponent from "./PreviewComponent";

    export default {
        name: "PreviewHamburgerMenuComponent",
        data () {
            return {
                allowClicks: true,
                pageWrapperId: "html"
            }
        },
        mixins: [
            PreviewComponent,
            HamburgerMenuComponent
        ]
    }
</script>

